import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import EventCard from '@/components/base/EventCard';
import { events } from '@/mocks/events';
import type { GossipEvent } from '@/types';

export default function HotToday() {
  const featured = events.filter((item) => item.featured).slice(0, 3) as GossipEvent[];
  const [main, ...rest] = featured;

  return (
    <section id="hot" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            kicker="今日热瓜"
            title="正在发酵的三件事"
            description="编辑按热度与更新频率挑出当下最值得先看的事件，每条都已排好完整时间线。"
          />
          <Link
            to="/timeline"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看全部事件
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {main && <EventCard event={main} variant="feature" />}
          <div className="flex flex-col gap-5">
            {rest.map((item) => (
              <EventCard key={item.id} event={item} variant="row" />
            ))}
            <div className="flex flex-1 flex-col justify-center rounded-lg border border-dashed border-background-300 bg-background-100 p-5">
              <div className="flex items-center gap-2 text-primary-600">
                <i className="ri-fire-line text-lg" />
                <span className="font-label text-sm">今日新增节点</span>
              </div>
              <p className="mt-2 font-heading text-3xl font-bold text-foreground-950">12 条</p>
              <p className="mt-1 text-sm text-foreground-600">
                过去 24 小时内，站内共有 12 个时间线节点被更新或补充。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}